import React, {useState} from "react";
import {Link} from "react-router-dom";
const Subscription = (props) => {
	if (props.account._type === "facebookPage") {
		return <form method="POST" action="/facebook/subscription">
			<input name="usertoken" type="hidden" value={props.token}/>
			<input name="actorid" type="hidden" value={props.user.id}/>
			<input name="token" type="hidden" value={props.account.access_token}/>
			<input name="isSubscribed" type="hidden" value={props.account.isSubscribed}/>
			<input name="accid" type="hidden" value={props.account.externalId}/>
			<input type="submit" value={props.account.isSubscribed ? "Unsubscribe" : "Subscribe"}/>
		</form>;

	}
	else {
		return <form method="POST" action="/twitter/subscription">
			<input name="id" type="hidden" value={props.account._id}/>
			<input name="actorid" type="hidden" value={props.user.id}/>
			<input name="isSubscribed" type="hidden" value={props.account.isSubscribed}/>
			<input type="submit" value={props.account.isSubscribed ? "Unsubscribe" : "Subscribe"}/>
		</form>;

	}
};


export default (props) => {
	const [showConfirm, setShowConfirm] = useState(false);
	return (<div className="account">
		{showConfirm && <div id="dialog">
			<div id="dialog-content">
				<div id="dialog-text">NB! Are you sure you want to delete this page? This is irreversable.</div>
				<div id="dialog-actions">
					<button  onClick={() => fetch(`/stream/${props.account._id}`, {
						method: "DELETE",
						credentials: "include",
						headers: {
							"Content-Type": "application/json"
						}
					}).then(() => {
						window.location.reload();
					})} className={"custombutton-red"} id="dialog-ok">OK</button>
					<button className={"custombutton-orig"} id="dialog-cancel"  onClick={() => setShowConfirm(false)}>Cancel</button>
				</div>
			</div>
		</div>}
		<div className="pageHeader">
			<div className="headerImageContainer">
				<img alt={props.account.photos[0]} src={props.account.photos[0]}/>
			</div>
			<div className="pageDescription">
				<div className={"pagename"}>{props.account.name}</div>
				<i className={props.account._type === "facebookPage" ? "fa fa-facebook-official" : "fa fa-twitter-square"}
				   aria-hidden="true"/>
			</div>
			<div className="manageContainer">
				<div className="delete">
					<button onClick={() => setShowConfirm(true)} className={"custombutton-red"}>DELETE <i className="fa fa-trash" aria-hidden="true"></i></button>
				</div>
				<div className="managePage">
					<Link to={"/messages/" + props.account._id}>Activity <i className="fa fa-comment-o"
																			   aria-hidden="true"></i></Link>
				</div>
				<div className="handleSubscription">
					{props.user.socialUser &&
					<Subscription account={props.account} token={props.user.socialUser.fb.access_token}
								  user={props.user}/>}

					{props.account.isSubscribed ?
						<div className="substatus subbed">is subscribed</div>
						:
						<div className="substatus">not subscribed</div>
					}
				</div>
			</div>
		</div>
		<div className="AccountInfo">
			<h4>Account info:</h4>
			<div>
				<div id={props.account.externalId}>
					orgid: {props.user.orgId}
					<br/>name: {props.account.name}
					<br/>groupid: {props.account.id}
					<br/>id: {props.account.externalId}
				</div>
				<div className={"copybutton"}
					 onClick={(e) => {
						 const copyText = document.getElementById(props.account.externalId);
						 if (document.selection) {
							 var range = document.body.createTextRange();
							 range.moveToElementText(copyText);
							 range.select();
						 }
						else if (window.getSelection()) {
							 var range = document.createRange();
							 range.selectNode(copyText);
							 window.getSelection().removeAllRanges();
							 window.getSelection().addRange(range);
						 }
						 document.execCommand("copy");
						 console.log("Copied Account info: " + range.startContainer.innerText);
					 }}
				>
					<i className="fa fa-clone"/>
				</div>
			</div>
		</div>
	</div>);
};



// WEBPACK FOOTER //
// ./src/components/Account.js